import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/shared';
import { StyledDrawerBox } from 'components/shared/CRUD/TableCRUDLayout.styles';
import ProtocolRuleForm from '../ProtocolRuleForm';

import type { ProtocolRuleDrawerProps } from './ProtocolRuleDrawer.types';

/**
 * Slides in from the right, from a rule's pencil or from "+ Regel toevoegen" below the grid. The
 * drawer unmounts its content once closed, so every opening starts from fresh form values.
 */
const ProtocolRuleDrawer = ({
  open,
  protocolId,
  rule,
  onClose,
  onSaved
}: ProtocolRuleDrawerProps) => {
  'use memo';
  const { t } = useTranslation('common');

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={
        rule
          ? t('adminPortal.protocols.ruleForm.editTitle')
          : t('adminPortal.protocols.ruleForm.createTitle')
      }
    >
      <StyledDrawerBox>
        {/* Keyed on the rule too, for switching rules before the closing drawer has unmounted */}
        <ProtocolRuleForm
          key={rule?.id ?? 'new'}
          protocolId={protocolId}
          rule={rule}
          onSaved={onSaved}
        />
      </StyledDrawerBox>
    </Drawer>
  );
};

export default ProtocolRuleDrawer;
